import { render, staticRenderFns } from "./SubmissionsList.vue?vue&type=template&id=434aa225&scoped=true&"
import script from "./SubmissionsList.vue?vue&type=script&lang=js&"
export * from "./SubmissionsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "434aa225",
  null
  
)

export default component.exports